import script from "./BasicInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInformation.vue?vue&type=script&setup=true&lang=js"

import "./BasicInformation.vue?vue&type=style&index=0&id=6d208d76&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d208d76"]])

export default __exports__